import { Command } from 'commands/Commands';

export class SetOrder extends Command {
  type: string = 'Partner.SetOrder';
  priority = 150;
}
